import { render } from "./GlobalLoad.vue?vue&type=template&id=702914ea&lang=pug"
import script from "./GlobalLoad.vue?vue&type=script&lang=js"
export * from "./GlobalLoad.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__